import Icon from "@ant-design/icons";
import React from "react";

import { ACIconProps } from "./ACIconWrapper";

export default function ArrowRightLeftIcon(props: ACIconProps) {
  return <Icon className="ac-icon" component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8.76034 5.29959C9.06387 5.01774 9.08145 4.54319 8.7996 4.23966C8.51774 3.93613 8.04319 3.91855 7.73966 4.2004L4.24137 7.44882C4.09295 7.58585 4 7.78207 4 8C4 8.21797 4.09299 8.41423 4.24145 8.55126L7.73966 11.7996C8.04319 12.0814 8.51774 12.0639 8.7996 11.7603C9.08145 11.4568 9.06387 10.9823 8.76034 10.7004L6.6599 8.75H15.25C15.6642 8.75 16 8.41421 16 8C16 7.58579 15.6642 7.25 15.25 7.25H6.6599L8.76034 5.29959Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M15.2004 12.2397C15.4823 11.9361 15.9568 11.9186 16.2603 12.2004L19.7585 15.4487C19.907 15.5858 20 15.782 20 16C20 16.218 19.907 16.4142 19.7585 16.5513L16.2603 19.7996C15.9568 20.0814 15.4823 20.0639 15.2004 19.7603C14.9186 19.4568 14.9361 18.9823 15.2397 18.7004L17.3401 16.75H8.75C8.33579 16.75 8 16.4142 8 16C8 15.5858 8.33579 15.25 8.75 15.25H17.3401L15.2397 13.2996C14.9361 13.0177 14.9186 12.5432 15.2004 12.2397Z"
        fill="currentColor"
      />
    </svg>
  );
};
